(() => {
  function removePrivacyContactAddress() {
    if (!window.location.pathname.includes('/policies/privacy-policy')) return;

    const policyBody = document.querySelector('.shopify-policy__body');
    if (!policyBody) return;

    const contactHeading = Array.from(policyBody.querySelectorAll('h1, h2, h3')).find(
      (heading) => heading.textContent.trim().toLowerCase() === 'contact'
    );
    const contactParagraph = contactHeading?.nextElementSibling;
    if (!(contactParagraph instanceof HTMLElement) || contactParagraph.tagName !== 'P') return;

    contactParagraph.innerHTML = contactParagraph.innerHTML.replace(
      /\s+or contact us at\s+[\s\S]*?(?=\.\s*(?:For the purpose|$))/i,
      ''
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removePrivacyContactAddress, { once: true });
  } else {
    removePrivacyContactAddress();
  }
})();
